import { Calendar, dateFnsLocalizer } from 'react-big-calendar'
import 'react-big-calendar/lib/css/react-big-calendar.css'

import format from 'date-fns/format'
import parse from 'date-fns/parse'
import startOfWeek from 'date-fns/startOfWeek'
import getDay from 'date-fns/getDay'
import enUS from 'date-fns/locale/en-US'

import { useNavigate } from 'react-router-dom'

const locales = {
  'en-US': enUS,
}

const localizer = dateFnsLocalizer({
  format,
  parse,
  startOfWeek,
  getDay,
  locales,
})

export const CountingsCalendar = ({countings, date, view, onNavigate, onView}) => {
    const navigate = useNavigate()

    const events = countings?.data?.map(counting => ({
        title: `${counting.store?.company?.name} - ${counting.store?.name}`,
        start: new Date(counting.date_start || counting.created_at),
        end: new Date(counting.date_start || counting.created_at),
        resource: counting,
    }))
  
    const handleSelectEvent = (event) => {
      navigate(`/counting/${event.resource._id}`)
    }
  

    return (
        <Calendar
      localizer={localizer}
      date={date}
      view={view}
      views={['month', 'week', 'day', 'agenda']}
      drilldownView='agenda'
      length={30}
      onNavigate={onNavigate}
      onView={onView}
      events={events}
      startAccessor='start'
      endAccessor='end'
      style={{ flex: 1, minHeight: 0 }}
      onSelectEvent={handleSelectEvent}
    />
    )
}
